import script from "./AppTypehead.vue?vue&type=script&lang=js"
export * from "./AppTypehead.vue?vue&type=script&lang=js"

import "./AppTypehead.vue?vue&type=style&index=0&id=6fe8dd20&scoped=true&lang=css"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe8dd20"]])

export default __exports__